import first from 'lodash/first'

const defaultRepeaterIDs = {
    $eventsRepeater: '#pastEventsRepeater',
    $pastEventTitle: '#pastEventTitle',
    $pastEventType: '#pastEventType',
    $pastEventButton: '#pastEventButton',
    $pastEventImage: '#pastEventImage'
}

export function renderPastEvents(pastEvents, repeaterIDs = defaultRepeaterIDs) {
    const { $eventsRepeater, $pastEventTitle, $pastEventType, $pastEventButton, $pastEventImage } = repeaterIDs

    $w($eventsRepeater).onItemReady(async ($item, itemData) => {
        const { title, thumbnail, eventType: { title: eventTypeTitle, image: eventTypeImage }, imageFromEvent, videoUrl } = itemData
        const isTitleTooLong = title.length >= 55

        $item($pastEventTitle).text = !isTitleTooLong ? title : `${title.substring(0,55)}...`
        $item($pastEventType).text = eventTypeTitle

        let imageToRender = imageFromEvent ? imageFromEvent : thumbnail
        if (!imageToRender) {
            if (videoUrl) {
                const youtubeThumbnail = getYoutubeThumbnail(videoUrl)
                imageToRender = youtubeThumbnail
            } else {
                imageToRender = eventTypeImage
            }
        }
        $item($pastEventImage).src = imageToRender

        const eventPage = itemData['link-events-events-title']
        $item($pastEventButton).link = eventPage
    })

    if (pastEvents.length < 6) {
        $w($eventsRepeater).data = pastEvents.slice(0, 3)
    } else {
        $w($eventsRepeater).data = pastEvents
    }
}

const getYoutubeThumbnail = (videoUrl) => {
    //taken and modified slightly from: https://gist.github.com/takien/4077195
    let youtubeID = ''

    const splitYoutubeUrl = videoUrl
        .replace(/(>|<)/gi, '')
        .split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);

    if (splitYoutubeUrl[2]) {
        youtubeID = splitYoutubeUrl[2].split(/[^0-9a-z_\-]/i);
        youtubeID = first(youtubeID)
    } else {
        youtubeID = splitYoutubeUrl;
    }

    const thumbnailUrl = `https://img.youtube.com/vi/${youtubeID}/0.jpg`

    return thumbnailUrl
}